import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import TrendingSection from './components/TrendingSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <LatestArticles />
        <TrendingSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}